export abstract class VoidedObject {
  dateCreated?: number | null;
  createdBy?: string | null;
  dateChanged?: number | null;
  changedBy?: string | null;
}
